<script setup lang="ts">
import { useDisplay } from 'vuetify';
import useLocale from '../../composables/useLocale';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faGlobe } from '@fortawesome/pro-regular-svg-icons';
import { storeToRefs } from 'pinia';
import useReaderStore from '../../stores/reader';

library.add(faGlobe);

type Emits = {
  (e: 'close'): void;
};
const emit = defineEmits<Emits>();

const { smAndDown } = useDisplay();
const { t } = useLocale();
const { isAudioOnly } = storeToRefs(useReaderStore());
</script>

<template>
  <v-card
    data-testid="bp-languages-card"
    class="mx-auto"
    :class="{ 'width-screen-100': smAndDown, 'accent-card': isAudioOnly }"
    min-width="320"
    :color="isAudioOnly ? 'surface' : 'inverse-surface'"
  >
    <v-card-title class="d-flex align-center">
      <FontAwesomeIcon class="mr-2" :class="{ 'pl-2': isAudioOnly }" icon="fa-regular fa-globe" />
      <span>{{ t('label_language_menu') }}</span>
      <v-spacer />
      <v-btn
        v-if="smAndDown"
        icon="mdi-close"
        variant="text"
        @click="emit('close')"
        :color="isAudioOnly ? 'on-surface' : 'primary'"
      >
      </v-btn>
    </v-card-title>
    <div class="d-flex flex-row ga-2 px-4 pb-4">
      <slot />
    </div>
  </v-card>
</template>

<style scoped lang="scss">
.v-card {
  padding-bottom: env(safe-area-inset-bottom, 0px);
}

.width-screen-100 {
  width: 100vw !important;
}

.accent-card {
  border-left: 10px solid rgb(var(--v-theme-brand-original)) !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
</style>
